import { NgModule } from '@angular/core';
import { ReferenceUiLazyModule } from './reference-ui-lazy.module';

@NgModule({
  imports: [ReferenceUiLazyModule],
})
export class ReferenceUiModule {}
